import React, { useMemo } from 'react';
import { Text } from 'react-native-paper';
import i18n from '../localization/i18n';
import { useTranslation } from 'react-i18next';
import getGlobalStyles from '../globalStyles';
import { useThemeSettings } from '../ThemeProvider';
import { useModalStore } from '../store/modalStore';
import { ButtonVariant, CustomButton } from './CustomButton';
import { View } from 'react-native';

const ConfirmationModal: React.FC<{ onClose: () => void }> = ({ onClose }) => {
  const modalProps = useModalStore((state) => state.modalAdditionalProps);
  const { t } = useTranslation();
  const { theme } = useThemeSettings();
  const gStyles = useMemo(() => getGlobalStyles(theme), [theme]);

  return (
    <>
      <Text style={[gStyles.header2, { alignSelf: 'center' }]}>
        {modalProps?.header}
      </Text>
      <Text style={gStyles.subtitle}>{modalProps?.message}</Text>
      {modalProps?.type === 'info' ?
        <CustomButton variant={ButtonVariant.NORMAL_PRIMARY} onPress={() => { onClose(); modalProps?.onConfirm; }}>Ok</CustomButton> :
        <View style={[gStyles.centerRow, { gap: 16 }]}>
          <CustomButton variant={ButtonVariant.NORMAL} disabled={modalProps?.isLoading} onPress={() => { onClose(); modalProps?.onReject?.(); }}>{modalProps?.rejectMessage ?? t("screens.common.no")}</CustomButton>
          <CustomButton variant={ButtonVariant.NORMAL_PRIMARY} disabled={modalProps?.isLoading} onPress={() => modalProps?.onConfirm(modalProps?.confirmData)}>{modalProps?.confirmMessage ?? t("screens.common.yes")}</CustomButton>
        </View>
      }
    </>
  );
}

export default ConfirmationModal;